import React from 'react';
import { useTheme } from '../ThemeContext';

const OPTIONS = [
  { id: 'system', label: 'System' },
  { id: 'light', label: 'Light' },
  { id: 'dark', label: 'Dark' },
];

/**
 * Light, Dark, or System. System is the default and clears a saved choice.
 * Selected text stays on a fill that clears WCAG AA in both themes.
 */
function AppearanceChoice() {
  const { colors, isDark, appearance, setAppearance } = useTheme();
  return (
    <div role="group" aria-label="Color theme" style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
      {OPTIONS.map((option) => {
        const selected = appearance === option.id;
        return (
          <button
            key={option.id}
            type="button"
            aria-pressed={selected}
            onClick={() => setAppearance(option.id)}
            style={{
              flex: '1 1 6rem',
              minHeight: '48px',
              padding: '0.75rem 1rem',
              borderRadius: '0.75rem',
              border: selected ? '2px solid #0f766e' : `2px solid ${colors.border}`,
              background: selected ? (isDark ? '#134e4a' : '#ccfbf1') : colors.surface,
              color: selected ? (isDark ? '#f9fafb' : '#134e4a') : colors.text,
              fontWeight: 650,
              fontSize: '1rem',
              cursor: 'pointer',
            }}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}

export default AppearanceChoice;
